export enum MenuActionOptionEnum {
  Undo = "undo",
  Redo = "redo"
}
